"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var idCounter = 0;
function id() {
  return idCounter++;
}
exports.id = id;